import * as React from 'react';
import BaseInput from './BaseInput';
import { InputProps, InputType, InputAttributes } from './Input.props';

import './primary_styles.scss';

const defaultAttributeProps: Partial<InputAttributes> = {
  type: InputType.Text
};

const Input = (props: InputProps): JSX.Element => {
  const fullProps = {
    ...props,
    attributes: {
      ...defaultAttributeProps,
      ...props.attributes
    }
  };
  const {
    attributes,
    children,
    input,
    submitAttempted,
    validationRules,
    options,
    selectValue
  } = fullProps;
  return (
    <BaseInput
      attributes={attributes}
      className={attributes.type === 'textarea' ? 'bf-textarea--primary' : 'bf-input--primary'}
      input={input}
      submitAttempted={submitAttempted}
      validationRules={validationRules}
      options={options}
      selectValue={selectValue}
    >
      {children}
    </BaseInput>
  );
};

export default Input;
